<template>
  <div class="checkout-page">
    <password-requirements :password="password" @validity-change="onValidityChange($event)"></password-requirements>
  </div>
</template>

<script>
import PasswordRequirements from '../components/auth/PasswordRequirements';

export default {
  name: 'checkout-page',
  components: {PasswordRequirements},
  data() {
    return {
      intervalId: null,
      password: '',
      valid: false,
    };
  },
  methods: {
    onValidityChange(valid) {
      this.valid = valid;
    },
    stopDisablingSubmitButton() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    keepDisablingSubmitButton() {
      this.intervalId = window.setInterval(() => this.setSubmitButtonDisabled(true), 200);
    },
    setSubmitButtonDisabled(disabled) {
      const element = document.getElementById('place_order');
      if (element) {
        element.disabled = disabled;
        element.title = disabled ? 'Enter valid password' : '';
      }
    },
    setPasswordInputValid(valid) {
      const element = document.getElementById('account_password');
      if (element) {
        element.classList.remove(valid ? 'sk-password-invalid' : 'sk-password-valid');
        element.classList.add(valid ? 'sk-password-valid' : 'sk-password-invalid');
      }
    },
    onPasswordInputKeyDown(event) {
      if (event.key === 'Enter' && !this.valid) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
  },
  watch: {
    valid: {
      immediate: true,
      handler(valid) {
        this.stopDisablingSubmitButton();
        if (valid) {
          this.setSubmitButtonDisabled(false);
        } else {
          this.keepDisablingSubmitButton();
        }
        this.setPasswordInputValid(valid);
      },
    },
  },
  mounted() {
    const input = document.getElementById('account_password');
    if (input) {
      input.addEventListener('input', event => (this.password = event.target.value));
      input.addEventListener('keydown', event => this.onPasswordInputKeyDown(event));
    }

    // prevent form from being submitted when the password is not valid
    $('form[name=checkout]').on('checkout_place_order', () => this.valid);
  },
};
</script>

<style lang="scss" scoped>
.checkout-page {
    text-align: left;
    padding: 0.5em 2em 1em;
}
</style>
